import { min, required, validate } from 'labguard-cdk'

const min0 = min(0)
const min1 = min(1)

export const validateSterilization = ({ threshold, coefficient, duration }) => ({
  threshold: validate([required, min1])(threshold),
  coefficient: validate([required, min1])(coefficient),
  duration: validate([required, min0])(duration),
})
